import { instance } from "api/apiBase";

const api = {
  getApplicantVerification: async (
    applicationId: number,
    applicantId: number,
    verificationId: number
  ) => {
    return (
      await instance.get(
        `/portal/v1/applications/${applicationId}/applicants/${applicantId}/verifications/${verificationId}`
      )
    ).data;
  }
};

export default api;
